/** Riven AbilitySpec seed kit (wiki residual numeric align). */
export const RIVEN_ABILITY_DEFS = [
  {
    id: 'riven_q',
    champKey: 'riven',
    slot: 'Q',
    name: 'Broken Wings',
    targeting: 'aoe_self',
    range: 260,
    castTime: 0,
    travelSpeed: null,
    width: null,
    radius: 260,
    cooldown: 13,
    manaCost: 0,
    costType: 'none',
    vfxId: 'riven_q',
    status: 'wired',
    qRadii: [260, 270, 280],
    qCycleWindowSec: 4
  },
  {
    id: 'riven_w',
    champKey: 'riven',
    slot: 'W',
    name: 'Ki Burst',
    targeting: 'aoe_self',
    range: 300,
    castTime: 0.25,
    travelSpeed: null,
    width: null,
    radius: 300,
    cooldown: 11,
    manaCost: 0,
    costType: 'none',
    vfxId: 'riven_w',
    cc: { type: 'stun', duration: 0.75 },
    status: 'wired'
  },
  {
    id: 'riven_e',
    champKey: 'riven',
    slot: 'E',
    name: 'Valor',
    targeting: 'dash',
    range: 250,
    castTime: 0,
    travelSpeed: null,
    width: null,
    radius: null,
    cooldown: 10,
    duration: 1.5,
    manaCost: 0,
    costType: 'none',
    vfxId: 'riven_e',
    status: 'wired'
  },
  {
    id: 'riven_r',
    champKey: 'riven',
    slot: 'R',
    name: 'Blade of the Exile',
    targeting: 'targeted',
    range: 1100,
    castTime: 0.25,
    travelSpeed: null,
    width: null,
    radius: null,
    cooldown: 120,
    duration: 15,
    manaCost: 0,
    costType: 'none',
    vfxId: 'riven_r',
    status: 'wired'
  }
];
